import { HttpClient } from "@angular/common/http";
import { inject, Injectable, WritableSignal } from '@angular/core';
import { tryExecuteAsync, TryResult } from "@app/utils/tryer";
import { firstValueFrom, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RequestHandlerService {
    private readonly _http = inject(HttpClient);

    async requesterHandler<T>(
        request: Observable<T>,
        statusSignal: WritableSignal<boolean>
    ): Promise<TryResult<T>> {
        return await tryExecuteAsync<T>(firstValueFrom(request), statusSignal);
    }

    async get<T>(url: string, statusSignal: WritableSignal<boolean>): Promise<TryResult<T>> {
        const request = this._http.get<T>(url);
        return await this.requesterHandler<T>(request, statusSignal);
    }

    async post<T>(url: string, body: any, statusSignal: WritableSignal<boolean>): Promise<TryResult<T>> {
        const request = this._http.post<T>(url, body);
        return await this.requesterHandler<T>(request, statusSignal);
    }

    async put<T>(url: string, body: any, statusSignal: WritableSignal<boolean>): Promise<TryResult<T>> {
        const request = this._http.put<T>(url, body);
        return await this.requesterHandler<T>(request, statusSignal);
    }

    async patch<T>(url: string, body: any, statusSignal: WritableSignal<boolean>): Promise<TryResult<T>> {
        const request = this._http.patch<T>(url, body);
        return await this.requesterHandler<T>(request, statusSignal);
    }

    async delete(url: string, statusSignal: WritableSignal<boolean>): Promise<TryResult<boolean>> {
        const request = this._http.delete(url);
        const response = await this.requesterHandler(request, statusSignal);
        return response.type === 'error' ? response : {type: 'success', data: true};
    }
}
